export enum getCoins_CoinGecko {
  Price = "https://api.coingecko.com/api/v3/simple/price",
  MarketData = "https://api.coingecko.com/api/v3/coins/markets",
  Trending = "https://api.coingecko.com/api/v3/search/trending",
  CoinData = `https://api.coingecko.com/api/v3/coins/`
}

export enum BinanceEndpointEnum {
  Kline = "https://api.binance.com/api/v3/klines",
}
